// src/components/profiles/ProfileListSkeleton.jsx
import React from 'react';
import { Grid, Card, CardContent, Skeleton, Box } from '@mui/material';

const ProfileListSkeleton = () => {
  return (
    <Grid container spacing={3}>
      {[1, 2, 3, 4, 5, 6].map((item) => (
        <Grid item xs={12} sm={6} md={4} key={item}>
          <Card sx={{ height: '100%' }}>
            <Skeleton variant="rectangular" height={200} />
            <CardContent>
              <Skeleton variant="text" height={32} width="60%" />
              <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                <Skeleton variant="text" height={24} width="30%" />
                <Skeleton variant="text" height={24} width="40%" />
              </Box>
              <Skeleton variant="text" height={20} width="80%" sx={{ mt: 2 }} />
              <Skeleton variant="text" height={20} width="70%" />
              <Skeleton variant="rectangular" height={36} sx={{ mt: 3, borderRadius: 1 }} />
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default ProfileListSkeleton;